import React from "react";
import { NavLink } from "react-router-dom";
import styled from "styled-components";
import Nav from "./Nav";

const Header = () => {
  return (
    <MainHeader>
      <NavLink to="https://sixthsens.ai">
        <h1 className="logo-link">SIXTHSENS AI</h1>
      </NavLink>
      <Nav />
    </MainHeader>
  );
};

const MainHeader = styled.header`
  padding: 0 4.8rem;
  height: 10rem;
  background-color: #37517e;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;

  .logo-link {
    font-family: "Jost", sans-serif;
    color: #FFFFFF;
    font-size: 30px;
    margin: 0;
    padding: 0;
    line-height: 1;
    font-weight: 500;
    letter-spacing: 2px;
    text-transform: uppercase;
      max-height: 40px;

  }
`;

export default Header;
